export enum StorefrontWidgetCheckoutButtonKind {
  Coverage = "coverage",
  NonCoverage = "non_coverage",
}
